window.onerror = function (message) {
    const suppressErrors = [
        "Cannot read properties of undefined (reading 'removeAttribute')",
        "Cannot read properties of null (reading 'querySelector')"
    ];
    if (suppressErrors.some((err) => message.includes(err))) {
        return true;
    }
    return false;
};

document.addEventListener('DOMContentLoaded', function() {
    // Menu highlighting for product pages
    if (window.location.pathname.startsWith('/products/')) {
        var productsMenuItem = document.querySelector('#HeaderMenu-products');
        if (productsMenuItem) {
            productsMenuItem.setAttribute('aria-current', 'page');
            var span = productsMenuItem.querySelector('span');
            if (span) {
                span.classList.add('header__active-menu-item');
            }
        }
    }

    // Check for specific burr product selectors
    const shankSelector = document.querySelector('select[name="options[Shank]"]');
    const cutSelector = document.querySelector('select[name="options[Cut]"]');
    const sizeSelector = document.querySelector('select[name="options[Size]"]');
    const isBurrProduct = shankSelector && cutSelector && sizeSelector;

    if (isBurrProduct) {
        // BURR PRODUCT LOGIC - Full cascading dropdown system
        const productHandle = window.location.pathname.split('/').filter(Boolean).pop();
        const priceElement = document.querySelector(".price-item.price-item--regular");
        const skuElement = document.querySelector(".product-sku__value");
        const stockIndicatorElement = document.querySelector(".stock-indicator");
        const variantInputElement = document.querySelector('input[name="id"].product-variant-id');
        const addToCartForm = document.querySelector("form[action='/cart/add']");
        const addToCartButton = document.querySelector("button.product-form__submit");
        
        const dropdownSelectors = [shankSelector, cutSelector, sizeSelector];

        fetch(`/products/${productHandle}.js`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch product data.");
                }
                return response.json();
            })
            .then((product) => {
                const variants = product.variants;
                if (!variants || !variants.length) {
                    throw new Error("No variants found in product data.");
                }

                // Initial dropdown setup
                updateDropdowns(0, variants, dropdownSelectors);

                // Attach change listeners
                dropdownSelectors.forEach((dropdown, index) => {
                    dropdown.addEventListener("change", () => {
                        updateDropdowns(index, variants, dropdownSelectors);
                    });
                });

                // Form submit validation
                if (addToCartForm) {
                    addToCartForm.addEventListener("submit", (event) => {
                        const selectedOptions = dropdownSelectors.map((dropdown) => dropdown.value || "");
                        const matchedVariant = findMatchingVariant(variants, selectedOptions);

                        if (!matchedVariant) {
                            event.preventDefault();
                            alert("Please select a valid variant before adding to the cart.");
                            return;
                        }

                        updateVariantInput(matchedVariant.id);
                    });
                }

                function updateDropdowns(changedIndex, variants, dropdownSelectors) {
                    const selectedOptions = dropdownSelectors.map((dropdown) => dropdown.value || "");

                    dropdownSelectors.forEach((dropdown, index) => {
                        if (index >= changedIndex) {
                            const validOptions = getValidOptions(index, selectedOptions, variants);
                            const previousValue = selectedOptions[index];

                            populateDropdown(dropdown, validOptions);

                            if (validOptions.includes(previousValue)) {
                                dropdown.value = previousValue;
                            } else {
                                dropdown.value = validOptions[0] || "";
                            }

                            selectedOptions[index] = dropdown.value;
                        }
                    });

                    const matchedVariant = findMatchingVariant(variants, selectedOptions);
                    if (matchedVariant) {
                        updatePriceAndSku(matchedVariant);
                        updateVariantInput(matchedVariant.id);
                    }
                }

                function getValidOptions(index, selectedOptions, variants) {
                    const validOptions = new Set();

                    variants.forEach((variant) => {
                        let isValid = true;
                        for (let i = 0; i < index; i++) {
                            if (selectedOptions[i] && variant[`option${i + 1}`] !== selectedOptions[i]) {
                                isValid = false;
                                break;
                            }
                        }

                        if (isValid) {
                            validOptions.add(variant[`option${index + 1}`]);
                        }
                    });

                    return Array.from(validOptions);
                }

                function populateDropdown(dropdown, validOptions) {
                    if (!dropdown) return;

                    dropdown.innerHTML = "";

                    validOptions.forEach((value) => {
                        const optionElement = document.createElement("option");
                        optionElement.value = value;
                        optionElement.textContent = value;
                        dropdown.appendChild(optionElement);
                    });
                }

                function findMatchingVariant(variants, selectedOptions) {
                    return variants.find((variant) => {
                        return selectedOptions.every((option, index) => variant[`option${index + 1}`] === option);
                    });
                }

                function updatePriceAndSku(variant) {
                    if (priceElement) {
                        priceElement.textContent = `$${(variant.price / 100).toFixed(2)}`;
                    }

                    if (skuElement) {
                        skuElement.textContent = variant.sku || "N/A";
                    }

                    // Fetch the actual rendered HTML for this variant to get stock status
                    if (stockIndicatorElement) {
                        const sectionElement = document.querySelector('[id^="MainProduct-"]');
                        
                        if (sectionElement) {
                            const sectionId = sectionElement.id.replace('MainProduct-', '');
                            const fetchUrl = `${window.location.pathname}?variant=${variant.id}&section_id=${sectionId}`;
                            
                            fetch(fetchUrl)
                                .then(response => response.text())
                                .then(html => {
                                    const parser = new DOMParser();
                                    const doc = parser.parseFromString(html, 'text/html');
                                    const newStockIndicator = doc.querySelector('.stock-indicator');
                                    
                                    if (newStockIndicator && stockIndicatorElement) {
                                        stockIndicatorElement.className = newStockIndicator.className;
                                        stockIndicatorElement.innerHTML = newStockIndicator.innerHTML;
                                    }
                                })
                                .catch(() => {});
                        }
                    }

                    if (addToCartButton) {
                        addToCartButton.disabled = false;
                        addToCartButton.removeAttribute('disabled');
                        addToCartButton.classList.remove("button--disabled");
                    }
                }

                function updateVariantInput(variantId) {
                    if (variantInputElement) {
                        variantInputElement.value = variantId;
                    }
                }
            })
            .catch(() => {});
    } else {
        // NON-BURR PRODUCTS - Minimal intervention to fix SKU, stock, and button
        const productHandle = window.location.pathname.split('/').filter(Boolean).pop();
        const skuElement = document.querySelector(".product-sku__value");
        const stockIndicatorElement = document.querySelector(".stock-indicator");
        const addToCartButton = document.querySelector("button.product-form__submit");
        const variantInput = document.querySelector('input[name="id"].product-variant-id');
        
        if (!variantInput) return;
        
        fetch(`/products/${productHandle}.js`)
            .then(response => response.json())
            .then(product => {
                const variants = product.variants;
                
                const updateCustomElements = () => {
                    const currentVariantId = parseInt(variantInput.value);
                    const currentVariant = variants.find(v => v.id === currentVariantId);
                    
                    if (currentVariant) {
                        // Update SKU
                        if (skuElement) {
                            skuElement.textContent = currentVariant.sku || "N/A";
                        }
                        
                        // Update stock indicator using Section Rendering API
                        if (stockIndicatorElement) {
                            const sectionElement = document.querySelector('[id^="MainProduct-"]');
                            
                            if (sectionElement) {
                                const sectionId = sectionElement.id.replace('MainProduct-', '');
                                const fetchUrl = `${window.location.pathname}?variant=${currentVariant.id}&section_id=${sectionId}`;
                                
                                fetch(fetchUrl)
                                    .then(response => response.text())
                                    .then(html => {
                                        const parser = new DOMParser();
                                        const doc = parser.parseFromString(html, 'text/html');
                                        const newStockIndicator = doc.querySelector('.stock-indicator');
                                        
                                        if (newStockIndicator && stockIndicatorElement) {
                                            stockIndicatorElement.className = newStockIndicator.className;
                                            stockIndicatorElement.innerHTML = newStockIndicator.innerHTML;
                                        }
                                    })
                                    .catch(() => {});
                            }
                        }
                        
                        // Always enable button
                        if (addToCartButton) {
                            addToCartButton.disabled = false;
                            addToCartButton.removeAttribute('disabled');
                            addToCartButton.classList.remove("button--disabled");
                        }
                    }
                };
                
                const observer = new MutationObserver(updateCustomElements);
                observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
                
                variantInput.addEventListener('change', updateCustomElements);
                
                updateCustomElements();
                
                let checkCount = 0;
                const buttonInterval = setInterval(() => {
                    if (addToCartButton) {
                        addToCartButton.disabled = false;
                        addToCartButton.removeAttribute('disabled');
                        addToCartButton.classList.remove("button--disabled");
                    }
                    checkCount++;
                    if (checkCount >= 10) clearInterval(buttonInterval);
                }, 200);
            })
            .catch(() => {});
    }
});